module.exports = __webpack_public_path__ + "img/capture.2a627c96.webp";